import { patchRecord } from '@/entities/shared/record/patch-record';
import type { Task } from '../schemas/task';
import { taskSchema } from '../schemas/task';

/** Change some fields; null removes one. */
export async function patchTask(
  id: string,
  patch: { readonly [K in keyof Task]?: Task[K] | null },
): Promise<void> {
  await patchRecord('tasks', taskSchema, id, patch);
}
